/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';

const GlobalMenuList = ({ children }) => <List component="nav">{children}</List>;

GlobalMenuList.propTypes = {
  children: PropTypes.any,
};

export default GlobalMenuList;
